<div class="pagination">
  <small class="pagination__description">
    {{ altFormattedText }}
  </small>
  <ul *ngIf="pagination.totalItems" class="pagination-content">
    <li
      (click)="previous()"
      [ngClass]="['pagination-content__previous', pagination.pageNumber === INITIAL_PAGE ? 'lock' : '']"
    >
      <small><mat-icon>navigate_before</mat-icon></small>
    </li>
    <li
      *ngFor="let item of totalPagesFakeArray; let index = index"
      [class.active]="pagination.pageNumber === index"
      (click)="setPage(index)"
    >
      <small>{{ index + 1 }}</small>
    </li>
    <li
      (click)="next()"
      [ngClass]="['pagination-content__next', pagination.pageNumber + 1 === totalPages ? 'lock' : '']"
    >
      <small>
        <mat-icon>navigate_next</mat-icon>
      </small>
    </li>
  </ul>
</div>
